import * as React from "react";
import themes from './themes';
import { ChakraProvider } from "@chakra-ui/react";
import Router from "routes";
import Fonts from "themes/fonts";
import AppConsts from "./libs/appconst";

export const App = (): React.ReactElement => {
    React.useEffect(() => {
        document.title = "Back Office " + AppConsts.APP_NAME;
    }, []);

    return (<ChakraProvider theme={themes}>
        <Fonts />
        <Router />
    </ChakraProvider>
    );
};